import Fire from './Fire.vue';

export default Fire;
